module.exports = __webpack_public_path__ + "assets/img/menu-profile.a6f9bc44.svg";